module.exports = __webpack_public_path__ + "static/img/platformNameFront.e5c2b5c9.png";